<label class="label-value-view"
       *ngIf="!noLabel && printLabel && isShowing(caracIdStateValue)">{{label}}{{label.endsWith('?') ?
  '' :
  ' :'}}
  <span *ngIf="required" class="required-block">*</span> </label>
<ndc-dynamic *ngIf="isShowing(caracIdStateValue)"
    [ndcDynamicComponent]="componentClass"
    [ndcDynamicInputs]="componentInputs"></ndc-dynamic>

